export default "__VITE_ASSET__Cnh5mbWm__"